/** AI 角色审核 / 聊天审核 — 状态文案与 pill 语义（与 linkTable statusPill 变体对齐） */

export const ROLE_REVIEW_STATUS_LABELS = new Map([
  [-11, '机审驳回'],
  [-21, '人审驳回'],
  [10, '待机审'],
  [20, '待人审'],
  [100, '审核通过'],
])

export const MEMORY_REVIEW_STATUS_LABELS = new Map([
  [0, '待审核'],
  [1, '审核通过'],
  [2, '审核失败'],
])

export function roleReviewStatusLabel(status) {
  return ROLE_REVIEW_STATUS_LABELS.get(status) || '—'
}

export function memoryReviewStatusLabel(status) {
  return MEMORY_REVIEW_STATUS_LABELS.get(status) || '—'
}

/** @returns {'online'|'offline'|'pending'|'failed'} */
export function roleReviewStatusPillVariant(status) {
  if (status === 100) return 'online'
  if (status === 10 || status === 20) return 'pending'
  if (status === -11 || status === -21) return 'failed'
  return 'offline'
}

/** @returns {'online'|'offline'|'pending'|'failed'} */
export function memoryReviewStatusPillVariant(status) {
  if (status === 1) return 'online'
  if (status === 0) return 'pending'
  if (status === 2) return 'failed'
  return 'offline'
}

export const CHAT_AVATAR = {
  role: 'https://cdn.kikakeyboard.com/2024-12-24/Uto0KDIlku-1735029950.png',
  user: 'https://cdn.kikakeyboard.com/2024-12-24/e9KmrpCDY5-1735033895.png',
}
